/**
 * Badminton live-court colour presets (presentation only — not match state).
 * Cycle order used by the scorecard colour control.
 */
export const BADMINTON_COURT_COLOURS = Object.freeze(["green", "wooden"]);

export const BADMINTON_COURT_COLOUR_DEFAULT = "green";

export const BADMINTON_COURT_COLOUR_LABELS = Object.freeze({
  green: "Green",
  wooden: "Wood",
});

/** Swatch chips for the toolbar control. */
export const BADMINTON_COURT_COLOUR_SWATCHES = Object.freeze({
  green: "#1c8a4f",
  wooden: "#b8956a",
});

export function normalizeBadmintonCourtColour(value) {
  if (BADMINTON_COURT_COLOURS.includes(value)) return value;
  return BADMINTON_COURT_COLOUR_DEFAULT;
}

export function nextBadmintonCourtColour(current) {
  const cur = normalizeBadmintonCourtColour(current);
  const i = BADMINTON_COURT_COLOURS.indexOf(cur);
  return BADMINTON_COURT_COLOURS[(i + 1) % BADMINTON_COURT_COLOURS.length];
}
